// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.5C13.1905 0.5 14.2406 1.09427 14.8724 2H21.5V22H2.5V2H9.12759C9.75936 1.09427 10.8095 0.5 12 0.5ZM10.5864 16.6569L17.6575 9.58584L16.2432 8.17163L10.5864 13.8285L7.75796 11.0001L6.34375 12.4143L10.5864 16.6569Z"}}]};

const AssignmentCheckedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'assignment-checked-filled',
    ref,
    icon: element,
  },
));

AssignmentCheckedFilledIcon.displayName = 'AssignmentCheckedFilledIcon';

export default AssignmentCheckedFilledIcon;
